<template>
  <div>
    <ValidationObserver ref="observer">
      <v-row align="center" :class="$vuetify.breakpoint.xs ? 'justify-center' : ''">
        <v-col cols="12" sm="12" md="3">
          <input-cadu
            title="Competência"
            v-model="competencia"
            icon="calendar"
            v-mask="'##/####'"
            :colorText="$vuetify.theme.themes.light.fontColor1"
            disabled
          />
        </v-col>
        <v-col cols="12" sm="12" md="3">
          <validation-provider name="ultimaAtualizacao" mode="eager" v-slot="{ errors }">
            <input-cadu
              :errorMessage="errors[0]"
              title="Última Atualização"
              v-model="ultimaAtualizacao"
              icon="calendar"
              v-mask="'##/##/####'"
              :colorText="$vuetify.theme.themes.light.fontColor1"
              disabled
            />
          </validation-provider>
        </v-col>
        <v-col cols="12" sm="12" md="3">
          <input-cadu
            title="Fonte"
            v-model="fonteAtualizacao"
            :colorText="$vuetify.theme.themes.light.fontColor1"
            disabled
          />
        </v-col>
        <v-col cols="12" sm="12" md="3">
          <validation-provider mode="eager" v-slot="{ errors }">
            <input-cadu
              :errorMessage="errors[0]"
              title="Tipo de Atualização"
              v-model="tipoAtualizacao"
              :colorText="$vuetify.theme.themes.light.fontColor1"
              disabled
            />
          </validation-provider>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2" style="padding-top: 40px" class="font13" v-if="isCompetenciaAntiga">PESSOA FISÍCA</v-col>
        <v-col cols="2" style="padding-top: 40px" class="font13" v-if="!isCompetenciaAntiga"
          >INDIVIDUAL OU FAMILIAR</v-col
        >
        <v-col sm="12" md="5" style="position: relative">
          <validation-provider rules="required|max:7" mode="eager" v-slot="{ errors }">
            <input-cadu
              :errorMessage="errors[0]"
              title="Custo Operacional / Pós Pagamento"
              onlyNumber
              max="7"
              :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###']"
              :disabled="disabledFields"
              v-model="pfCustoOperacional"
              :colorText="'#00995d'"
              textAlign="end"
            />
          </validation-provider>
          <div style="position: absolute; left: 94%; top: 10%">
            <tooltip-help
              width="400"
              text="Contrato que têm o valor da contraprestação pecuniária calculado após a realização das despesas com as coberturas contratadas, podendo ser utilizado nas opções de Rateio ou Custo Operacional."
            />
          </div>
        </v-col>
        <v-col sm="12" md="5" style="position: relative">
          <validation-provider rules="required" mode="eager" v-slot="{ errors }">
            <input-cadu
              :errorMessage="errors[0]"
              title="Pré Pagamento / Pré-estabelecido"
              v-model="pfPrePagamento"
              :disabled="disabledFields"
              :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###']"
              onlyNumber
              :colorText="'#00995d'"
              textAlign="end"
            />
          </validation-provider>
          <div style="position: absolute; left: 90%; top: 10%">
            <tooltip-help
              width="400"
              text="Contrato que têm o valor da contraprestação pecuniária calculado antes da utilização das coberturas contratadas."
            />
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2" class="font13" v-if="!isCompetenciaAntiga">COLETIVO EMPRESARIAL</v-col>
        <v-col cols="2" class="font13" v-if="isCompetenciaAntiga">PESSOA JURÍDICA</v-col>
        <v-col sm="12" md="5">
          <validation-provider rules="required" mode="eager" v-slot="{ errors }">
            <input-cadu
              :errorMessage="errors[0]"
              v-model="pjCustoOperacional"
              :disabled="disabledFields"
              :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###']"
              onlyNumber
              :colorText="$vuetify.theme.themes.light.fontColor1"
              textAlign="end"
            />
          </validation-provider>
        </v-col>
        <v-col sm="12" md="5">
          <validation-provider rules="required" mode="eager" v-slot="{ errors }">
            <input-cadu
              :errorMessage="errors[0]"
              v-model="pjPrePagamento"
              :disabled="disabledFields"
              :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###']"
              onlyNumber
              :colorText="$vuetify.theme.themes.light.fontColor1"
              textAlign="end"
            />
          </validation-provider>
        </v-col>
      </v-row>
      <v-row v-if="!isCompetenciaAntiga">
        <v-col cols="2" class="font13">COLETIVO POR ADESÃO</v-col>
        <v-col sm="12" md="5">
          <validation-provider rules="required" mode="eager" v-slot="{ errors }">
            <input-cadu
              :errorMessage="errors[0]"
              v-model="pjAdesaoCustoOperacional"
              :disabled="disabledFields"
              :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###']"
              onlyNumber
              :colorText="$vuetify.theme.themes.light.fontColor1"
              textAlign="end"
            />
          </validation-provider>
        </v-col>
        <v-col sm="12" md="5">
          <validation-provider rules="required" mode="eager" v-slot="{ errors }">
            <input-cadu
              :errorMessage="errors[0]"
              v-model="pjAdesaoPrePagamento"
              :disabled="disabledFields"
              :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###']"
              onlyNumber
              :colorText="$vuetify.theme.themes.light.fontColor1"
              textAlign="end"
            />
          </validation-provider>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2"></v-col>
        <v-col cols="5">
          <div class="font-weight" style="text-align: end" v-if="!isCompetenciaAntiga">
            Total de Beneficiários Unimed:
          </div>
          <div class="font-weight" style="text-align: end" v-if="isCompetenciaAntiga">Total de Beneficiários:</div>
        </v-col>
        <v-col cols="5">
          <input-cadu
            :value="totalBeneficiarioFormatado"
            colorBgField="#333"
            colorInput="white"
            :colorText="$vuetify.theme.themes.light.fontColor1"
            disabled
            textAlign="end"
          />
        </v-col>
      </v-row>
      <v-row v-if="!isCompetenciaAntiga">
        <v-col cols="2"></v-col>
        <v-col cols="5">
          <div class="font-weight" style="text-align: end">Total de Beneficiários AutoGestão (Cessão de Rede):</div>
        </v-col>
        <v-col cols="5">
          <input-cadu
            v-if="disabledFields"
            :value="totalBeneficiarioAutoGestaoFormatado"
            colorBgField="#333"
            colorInput="white"
            :colorText="$vuetify.theme.themes.light.fontColor1"
            textAlign="end"
            disabled
          />

          <validation-provider rules="required" mode="eager" v-slot="{ errors }">
            <input-cadu
              v-if="!disabledFields"
              :errorMessage="errors[0]"
              v-model="totalBeneficiarioAutoGestao"
              :value="totalBeneficiarioAutoGestao"
              :mask="[
                '####',
                '#.###',
                '##.###',
                '###.###',
                '####.###',
                '#.###.###',
                '##.###.###',
                '###.###.###',
                '#.###.###.###'
              ]"
              onlyNumber
              max="10"
              :colorText="$vuetify.theme.themes.light.fontColor1"
              textAlign="end"
            />
          </validation-provider>
        </v-col>
      </v-row>
    </ValidationObserver>
    <modal-cancelar v-model="showModalCancelar" @cancelar-edicao="cancelarEdicao()" />
  </div>
</template>
<script>
import jwtDecode from 'jwt-decode'
import Beneficiario from '@/services/Perfil/Beneficiario'
import BeneficiarioCadbenefService from '@/services/BeneficiarioCadbenefService'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { EventBus } from '../../../../../services/EventBus/EventBus'
import { cloneDeep, isEqual } from 'lodash'
import { mask } from 'vue-the-mask'

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  directives: {
    mask
  },
  props: {
    editProp: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      competencia: '',
      competenciaClone: '',
      ultimaAtualizacao: '',
      tipoAtualizacao: 'Manual',
      fonteAtualizacao: 'CADBENEF',
      pfCustoOperacional: 0,
      pfPrePagamento: 0,
      pjCustoOperacional: 0,
      pjPrePagamento: 0,
      pjAdesaoCustoOperacional: 0,
      pjAdesaoPrePagamento: 0,
      totalBeneficiarioAutoGestao: 0,
      atualizacao: true,
      role: '',
      tokenBearer: '',
      // DatePicker
      menuOpen: false,
      inputTitle: 'Competência',
      allowedMonths: [],
      loading: this.value,
      id: '',
      editavel: false,
      edit: false,
      cloneBeneficiario: {},
      showModalCancelar: false,
      disabledFields: true,
      isCompetenciaAntiga: false
    }
  },
  async beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    let decoded = jwtDecode(this.tokenBearer)
    this.role = decoded.role

    await this.loadBenefiario()

    EventBus.$on('carregarTableBeneficiario', (carregar) => {
      if (carregar) {
        this.getBeneficiario()
        EventBus.$emit('carregarTableBeneficiario', false)
      }
    })
  },
  methods: {
    async loadBenefiario() {
      // consulta beneficiarios
      this.getBeneficiario()

      // consulta pendencias
      this.getPendencias()
    },
    async consultarCompetenciaCadbenef(reenviarComErro = false) {
      EventBus.$emit('atualizacaoCadbenefPerfil', { loading: true, loadingError: false })
      const beneficiarioService = new BeneficiarioCadbenefService(this.tokenBearer, this.$appConfig.config.API)

      await beneficiarioService
        .consultarCompetenciaBeneficiariosCadbenef(this.competencia, [this.$idUnimed], reenviarComErro)
        .then((res) => {
          this.tratarResposta(this.$idUnimed, res.data)
          this.$emit('success', {
            origin: 'atualizacaoCadbenef',
            message: 'Consulta de beneficiários realizada com sucesso!'
          })
        })
        .catch((err) => this.$emit('error', err))
        .finally(() => {
          EventBus.$emit('atualizacaoCadbenefPerfil', { loading: false, loadingError: false })
        })
    },
    async getBeneficiario() {
      this.loading = true

      const beneficiario = new Beneficiario(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      await beneficiario
        .getUltimoBeneficiario()
        .then((res) => {
          if (!res.data) this.$emit('editavel', true)
          else {
            const data = res.data
            this.cloneBeneficiario = cloneDeep(data)
            this.competencia = data.competencia
            this.competenciaClone = data.competencia
            this.ultimaAtualizacao = data.dataAtualizacao
            this.tipoAtualizacao = data.tipoAtualizacao
            this.pfCustoOperacional = data.qtPessoaFisicaCustoOperacional
            this.pfPrePagamento = data.qtPessoaFisicaPrePagamento
            this.pjCustoOperacional = data.qtPessoaJuridicaCustoOperacional
            this.pjPrePagamento = data.qtPessoaJuridicaPrePagamento
            this.totalBeneficiarioAutoGestao = data.qtAutoGestao == null ? 0 : data.qtAutoGestao
            this.id = data.id
            this.editavel = data.editavel

            // campos novos
            this.pjAdesaoCustoOperacional =
              data.qtPessoaJuridicaAdesaoCustoOperacional == null ? 0 : data.qtPessoaJuridicaAdesaoCustoOperacional
            this.pjAdesaoPrePagamento =
              data.qtPessoaJuridicaAdesaoPrePagamento == null ? 0 : data.qtPessoaJuridicaAdesaoPrePagamento
            this.fonteAtualizacao = data.fonteAtualizacao !== null ? data.fonteAtualizacao : 'UNIMED'

            this.checkDisabledField()
          }
        })
        .catch((err) => this.$emit('error', err))
        .finally(() => (this.loading = false))
    },
    async getPendencias() {
      this.loading = true
      const beneficiario = new Beneficiario(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)
      await beneficiario
        .getPendentesBeneficiarios()
        .then((res) => (this.allowedMonths = res.data))
        .catch((err) => this.$emit('error', err))
        .finally(() => (this.loading = false))
    },
    async cancelarEdicao() {
      await this.loadBenefiario()
      this.showModalCancelar = false
    },
    competenciaEquals(mesFormatado, mesSemFormatacao) {
      let arrMes = mesSemFormatacao.split('-')
      let mesComFormatacao = `${arrMes[1]}/${arrMes[0]}`
      return mesFormatado === mesComFormatacao
    },
    async putBeneficiario(justificativa = '') {
      let validate = await this.$refs.observer.validate()
      let data = {
        competencia: this.competencia,
        id: this.id,
        qtPessoaFisicaCustoOperacional: this.pfCustoOperacional,
        qtPessoaFisicaPrePagamento: this.pfPrePagamento,
        qtPessoaJuridicaCustoOperacional: this.pjCustoOperacional,
        qtPessoaJuridicaPrePagamento: this.pjPrePagamento,
        qtPessoaJuridicaAdesaoCustoOperacional: this.pjAdesaoCustoOperacional,
        qtPessoaJuridicaAdesaoPrePagamento: this.pjAdesaoPrePagamento,
        qtAutoGestao: this.totalBeneficiarioAutoGestao,
        tipoAtualizacao: 'MANUAL',
        fonteAtualizacao: 'UNIMED',
        justificativa,
        atualizacaoOnline: this.cloneBeneficiario.atualizacaoOnline
      }

      if (validate && !this.isEqualsCompetencias(this.cloneBeneficiario, data)) {
        const beneficiario = new Beneficiario(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)
        await beneficiario
          .putBeneficiario(data)
          .then((res) => {
            const mensagem = res.data.mensagem
            const gerouPendencia = res.data.gerouPendencia

            if (gerouPendencia) {
              this.$emit('gerouPendencia', { mensagem, gerouPendencia })
            } else {
              this.id = res.data.idCompetencia
              this.$emit('success', {
                origin: 'atualizacaoBeneficiarios',
                message: 'Informações de beneficiários salvas com sucesso!'
              })
            }
          })
          .catch((err) => {
            this.getBeneficiario()
            this.$emit('error', err.response)
          })
      } else {
        let errorObject = {
          data: {
            status: 304,
            message: 'Não foram identificadas alterações na quantidade de beneficiários atuais !'
          }
        }
        this.$emit('error', errorObject)
      }
    },
    convertDate(text) {
      if (!text) {
        return text
      } else {
        let competencia = text.split('-')
        return `${competencia[2]}/${competencia[1]}/${competencia[0]}`
      }
    },
    tratarResposta(idUnimed, response) {
      if (!!response.unimeds && response.unimeds.length > 0 && response.unimeds[0].codigoUnimed == idUnimed) {
        let resultadoUnimed = response.unimeds[0]
        let contratos = resultadoUnimed.tipoContrato.contrato
        let prePagamento = contratos.filter((contrato) => contrato.tipoContrato === 'Pré-Pagamento')
        let custoOperacional = contratos.filter((contrato) => contrato.tipoContrato === 'Custo Operacional')
        this.totalBeneficiarioAutoGestao = resultadoUnimed.totalAutoGestao

        this.tipoAtualizacao = !!resultadoUnimed.tipoAtualizacao
          ? resultadoUnimed.tipoAtualizacao.toLocaleUpperCase()
          : 'MANUAL'
        this.ultimaAtualizacao = this.convertDate(resultadoUnimed.dataRequisicao)

        if (!!prePagamento && prePagamento.length > 0) {
          this.pjAdesaoPrePagamento = prePagamento[0].coletivoAdesao
          this.pjPrePagamento = prePagamento[0].coletivoEmpresarial
          this.pfPrePagamento = prePagamento[0].individualFamiliar
        } else {
          this.pjAdesaoPrePagamento = 0
          this.pjPrePagamento = 0
          this.pfPrePagamento = 0
        }

        if (!!custoOperacional && custoOperacional.length > 0) {
          this.pjAdesaoCustoOperacional = custoOperacional[0].coletivoAdesao
          this.pjCustoOperacional = custoOperacional[0].coletivoEmpresarial
          this.pfCustoOperacional = custoOperacional[0].individualFamiliar
        } else {
          this.pjAdesaoCustoOperacional = 0
          this.pjCustoOperacional = 0
          this.pfCustoOperacional = 0
        }
      }
    },
    clean() {
      this.pfCustoOperacional = 0
      this.pfPrePagamento = 0
      this.pjCustoOperacional = 0
      this.pjPrePagamento = 0
    },
    selecionarData(data) {
      if (data.length === 7 && data !== this.competencia) {
        this.editavel = true
        this.$emit('editavel', this.editavel)
        this.competencia = data
        this.clean()
        this.checkDisabledField()
      }
    },
    isEqualsCompetencias(c1, c2) {
      return (
        c1.id === c2.id &&
        String(c1.qtPessoaFisicaCustoOperacional) === String(c2.qtPessoaFisicaCustoOperacional) &&
        String(c1.qtPessoaFisicaPrePagamento) === String(c2.qtPessoaFisicaPrePagamento) &&
        String(c1.qtPessoaJuridicaCustoOperacional) === String(c2.qtPessoaJuridicaCustoOperacional) &&
        String(c1.qtPessoaJuridicaPrePagamento) === String(c2.qtPessoaJuridicaPrePagamento) &&
        String(c1.qtPessoaJuridicaAdesaoCustoOperacional) === String(c2.qtPessoaJuridicaAdesaoCustoOperacional) &&
        String(c1.qtPessoaJuridicaAdesaoPrePagamento) === String(c2.qtPessoaJuridicaAdesaoPrePagamento) &&
        String(c1.qtAutoGestao) === String(c2.qtAutoGestao)
      )
    },
    formatDateCompetencia(x, y) {
      var z = {
        M: x.getMonth() + 1,
        d: x.getDate(),
        h: x.getHours(),
        m: x.getMinutes(),
        s: x.getSeconds()
      }
      y = y.replace(/(M+|d+|h+|m+|s+)/g, function (v) {
        return ((v.length > 1 ? '0' : '') + z[v.slice(-1)]).slice(-2)
      })

      return y.replace(/(y+)/g, function (v) {
        return x.getFullYear().toString().slice(-v.length)
      })
    },
    checkDisabledField() {
      const competencia = this.convertCompetencia(this.competencia)
      // habilita os campos do formulario
      if (!this.editProp && this.role === 'admin_brasil') {
        this.disabledFields = false
      } else {
        this.disabledFields = true
      }

      // Ativa o butão de atualização de competência beneficiarios
      if (competencia > '2022-11') {
        EventBus.$emit('permiteAtualizarCadbenef', !this.editProp)
      } else {
        this.isCompetenciaAntiga = true
      }

      this.$emit('editavel', !this.disabledFields)
    },
    convertCompetencia(text) {
      if (!text) {
        return text
      } else {
        let competencia = text.split('/')
        return `${competencia[1]}-${competencia[0]}`
      }
    },
    convertCompetenciaYearMonth(text) {
      if (!text) {
        return text
      } else {
        let competencia = text.split('/')
        return `${competencia[1]}${competencia[0]}`
      }
    },
    formatarMilhar(valor) {
      return String(Number(valor) || 0).replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
  },
  watch: {
    loading() {
      this.$emit('input', this.loading)
    }
  },
  computed: {
    isMonthEmpty() {
      return this.allowedMonths.length === 0
    },
    candEditAtt() {
      return this.role === 'admin_brasil' && this.edit
    },
    canEdit() {
      return this.role === 'admin_brasil' && this.edit
    },
    totalBeneficiario() {
      let a = this.pfCustoOperacional * 1 || 0
      let b = this.pfPrePagamento * 1 || 0
      let c = this.pjCustoOperacional * 1 || 0
      let d = this.pjPrePagamento * 1 || 0
      let e = this.pjAdesaoCustoOperacional * 1 || 0
      let f = this.pjAdesaoPrePagamento * 1 || 0
      let result = (a + b + c + d + e + f) * 1 || 0
      return result
    },
    totalBeneficiarioFormatado() {
      return this.formatarMilhar(this.totalBeneficiario)
    },
    totalBeneficiarioAutoGestaoFormatado() {
      return this.formatarMilhar(this.totalBeneficiarioAutoGestao)
    }
  }
}
</script>

<style scoped>
.font13 {
  font-size: 13px;
}
</style>
